import RelendLogo from "@/assets/icons/relend-light.svg"
import { MySupplyBorrow } from "@/components/dashboard/mySupplyBorrow"
import useTrans from "@/hooks/useTrans"
import { Stack, Typography } from "@mui/material"
import Image from "next/image"
import React from "react"
import StakeAndEarn from "./components/StakeAndEarn"
import ClaimNFTVoucher from "./components/ClaimNFTVoucher"
import { BlockchainNetwork } from "@renec-foundation/relend-adapter"

interface IViewProps {
  network: BlockchainNetwork
}
const View = ({ network }: IViewProps) => {
  const trans = useTrans()

  return (
    <Stack direction={{ xs: "column", sm: "column", md: "row" }} gap={2} className='mt-4'>
      <Stack
        className='relative py-4 px-5 bg-white rounded-lg border border-solid border-secondary min-w-80 min-h-full'
        gap={3}
        data-testid='my-account-others-assets'
      >
        <Stack gap={1}>
          <Typography className='text-neutral-1000 font-bold text-xl'>{trans.dashboard.hero.others}</Typography>
          {/* TODO: Temporary disable daily reward */}
          {/* <DailyReward /> */}
        </Stack>

        <ClaimNFTVoucher />

        {network === BlockchainNetwork.RENEC && <StakeAndEarn />}

        <Image className='absolute bottom-0 right-0 z-0' src={RelendLogo} alt='relend' width={75} height={79} />
      </Stack>
      <Stack className='flex-1 py-6 px-4 sm:px-6 bg-white rounded-lg border border-solid border-secondary'>
        <MySupplyBorrow />
      </Stack>
    </Stack>
  )
}

export default View
